import { useCallback } from "react";
import { useTranslation } from "next-i18next";
import { sortListByAttribute } from "./sort-utils";
import {
  CargillRequestReason,
  useCargillDefaultRequestReasons,
} from "./useCargillDefaultRequestReasons";

/**
 * This hook returns a function that returns in place a merged set of translated
 * request reasons based on input.
 * @returns
 */
export function useGetTranslatedReasons() {
  const { t, i18n } = useTranslation();
  const other = t("request_access:more_information.other");
  const defaultRequestReasons = useCargillDefaultRequestReasons();

  const getTranslatedReasons = useCallback(
    function getTranslatedReasons(requestedPortalReasons: string[]) {
      const translatedReasons = requestedPortalReasons.map((item) => {
        let translated: CargillRequestReason | undefined =
          defaultRequestReasons.find(
            (translation) => translation.reasonEnglishKey === item
          );

        if (!translated) {
          translated = {
            reason: item,
            reasonEnglishKey: item,
          };
        }

        return translated;
      });

      const sortedList = sortListByAttribute(
        "reason",
        translatedReasons,
        other
      );

      return sortedList;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [other, defaultRequestReasons, i18n.language]
  );

  return getTranslatedReasons;
}
